import { Formatter } from '@stamhoofd/utility';
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Pending"] = "Pending";
    PaymentStatus["Failed"] = "Failed";
    PaymentStatus["Succeeded"] = "Succeeded";
    PaymentStatus["Created"] = "Created";
})(PaymentStatus || (PaymentStatus = {}));
export class PaymentStatusHelper {
    static getName(method) {
        switch (method) {
            case PaymentStatus.Pending: return 'wacht op betaling';
            case PaymentStatus.Created: return 'wacht op betaling';
            case PaymentStatus.Succeeded: return 'ontvangen';
            case PaymentStatus.Failed: return 'mislukt/geannuleerd';
        }
    }
    static getNameCapitalized(method) {
        return Formatter.capitalizeFirstLetter(PaymentStatusHelper.getName(method));
    }
}
//# sourceMappingURL=PaymentStatus.js.map